var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"ExportWorkers"}},[_c('button',{attrs:{"name":"btnExport"},on:{"click":_vm.exportExcel}},[_vm._v("\n    "+_vm._s(_vm.$t("ExportWorkerList_btnExport"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }